module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/saas-2-fe2405bc9fe2a49543b8233332e24597.jpg";